import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import Footer from "./widgets/Footer";
import iconStepOne from "../img/icon-step1.svg";
import iconStepTwo from "../img/icon-step2.svg";
import mixpanel from "mixpanel-browser";
import { AB_VERSION } from "../constants";

const Test = () => {
  const clickDownload = () => {
    const currentMixpanelId = mixpanel.get_distinct_id();

    window.location.replace(
      `https://www.ahead-app.com/sat/question?qpid=123&qid=14&distinct_id=${currentMixpanelId}`
    );
  };

  useEffect(() => {
    mixpanel.track(`$pageview-sat:feedback-finished`, {
      page: `feedback-finished`,
      abVersion: AB_VERSION,
    });
  }, []);

  return (
    <div className="container">
      <div className="flex flex-col items-center align-middle justify-center gap-12 mt-20 mx-2">
        <div className="text-center">
          <h4 className="fs-24 fSb pb-3">You are a great friend!</h4>
          <h3 className="fs-22 w-5/6 m-auto">
            Want to see how you could improve your emotional intelligence too?
          </h3>
        </div>
        <div className="flex flex-col md:flex-row gap-15 mx-auto text-center">
          <div className="flex flex-col items-center gap-3 max-w-[262px]">
            <img src={iconStepOne} alt="" />
            <p className="fs-22 m-0">Step 1</p>
            <p className="text-lg text-[#212121]/60 w-5/6">
              Share feedback about your friend
            </p>
          </div>
          <div className="flex flex-col items-center gap-3 max-w-[262px]">
            <img src={iconStepTwo} alt="" />
            <p className="fs-22 m-0">Step 2</p>
            <p className="text-lg text-[#212121]/60">
              Learn how to improve your emotional intelligence
            </p>
          </div>
        </div>
      </div>

      <div className="sticky bottom-6 z-20 flex justify-center mt-10">
        <Button
          className="btn-lg w-[250px] mt-1"
          onClick={() => clickDownload()}
          style={{ height: "58px" }}
        >
          <span className="text-white">Sure!</span>
        </Button>
      </div>

      <div className="flex flex-col justify-center mt-20">
        <div className="m-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Test;
